<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Tipo de blocks</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Panel de control</span>
    </div>
  </div>

  <div class="d-flex my-xl-auto right-content align-items-center">
    <button class="btn btn-secondary header-add-btn" type="button" (click)="abrirModalAgregar(mdlAgregarTipoPrecio)">
      Agregar
    </button>
  </div>
</div>

<div class="row row-sm">
  <div class="col-xl-12">
    <div class="card overflow-visible">
      <div class="card-body">
        @if (cargando) {
          <div class="text-center">
            <div class="spinner-grow" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <br>
              <p class="text-center">Consultando por favor espere...</p>
            </div>
          }

          @if (!cargando && tipoPrecios.length === 0) {
            <div class="empty-state">
              <div class="empty-state__icon">
                <i class="fa fa-tags"></i>
              </div>
              <h5>No hay tipos de precios registrados</h5>
              <p>Cuando tu backend responda con datos, aparecerán aquí.</p>
            </div>
          }

          @if (!cargando && tipoPrecios.length > 0) {
            <div class="table-responsive d-none d-md-block">
              <table datatable [dtOptions]="dtOptions" class="table table-bordered table-striped table-hover dt-ext">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nombre</th>
                    <th>Fecha de registro</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  @for (tipoPrecio of tipoPrecios; track tipoPrecio; let i = $index) {
                    <tr>
                      <td>{{ i + 1 }}</td>
                      <td class="text-uppercase">{{ tipoPrecio.DES_TIPPREC }}</td>
                      <td>{{ tipoPrecio.FEC_TIPPREC ? (tipoPrecio.FEC_TIPPREC | date:'dd/MM/yyyy hh:mm a') : '-' }}</td>
                      <td>
                        <div class="action-group">
                          <button class="btn btn-warning btn-sm" type="button" (click)="abrirModalEditar(mdlEditarTipoPrecio, tipoPrecio)">
                            <i class="zmdi zmdi-edit text-white"></i>
                          </button>
                          <button class="btn btn-danger btn-sm" type="button" (click)="eliminarTipoPrecio(tipoPrecio)">
                            <i class="fa fa-times"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }

          @if (!cargando && tipoPrecios.length > 0) {
            <div class="mobile-list d-md-none">
              @for (tipoPrecio of tipoPrecios; track tipoPrecio; let i = $index) {
                <article class="mobile-card">
                  <div class="mobile-card__head">
                    <span class="mobile-index">#{{ i + 1 }}</span>
                    <span class="mobile-date">
                      {{ tipoPrecio.FEC_TIPPREC ? (tipoPrecio.FEC_TIPPREC | date:'dd/MM/yyyy hh:mm a') : '-' }}
                    </span>
                  </div>
                  <div class="mobile-card__name">
                    {{ tipoPrecio.DES_TIPPREC }}
                  </div>
                  <div class="mobile-card__actions">
                    <button class="btn btn-warning btn-sm" type="button" (click)="abrirModalEditar(mdlEditarTipoPrecio, tipoPrecio)">
                      Editar
                    </button>
                    <button class="btn btn-danger btn-sm" type="button" (click)="eliminarTipoPrecio(tipoPrecio)">
                      Eliminar
                    </button>
                  </div>
                </article>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <ng-template #mdlAgregarTipoPrecio let-modal>
    <div class="modal-header">
      <h6 class="modal-title">Agregar tipo precio</h6>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="form-group mb-0">
        <label class="form-label">Nombre</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="nuevoTipo"
          placeholder="Ingresar"
          [disabled]="guardando">
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="modal.dismiss('cancel')" [disabled]="guardando">Salir</button>
      <button type="button" class="btn btn-secondary" (click)="crearTipoPrecio()" [disabled]="guardando">
        {{ guardando ? 'Guardando...' : 'Guardar' }}
      </button>
    </div>
  </ng-template>

  <ng-template #mdlEditarTipoPrecio let-modal>
    <div class="modal-header">
      <h6 class="modal-title">Editar tipo precio</h6>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="form-group mb-0">
        <label class="form-label">Nombre</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="editarTipo"
          placeholder="Ingresar"
          [disabled]="guardando">
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="modal.dismiss('cancel')" [disabled]="guardando">Salir</button>
      <button type="button" class="btn btn-secondary" (click)="actualizarTipoPrecio()" [disabled]="guardando">
        {{ guardando ? 'Guardando...' : 'Guardar cambios' }}
      </button>
    </div>
  </ng-template>
